import { useParams } from "react-router";

export const useSelectedOrganization = () => {
  const { organizationId } = useParams();

  return { selectedOrganizationId: organizationId };
};
